import React, { useState, useRef } from 'react';
import DocumentViewerButtonBar from './DocumentViewerButtonBar'; // Import the new component
import { useGlobalProvider } from '../contexts/GlobalProvider';

const AssetsButtonBar = ({
    onGetDocuments,
    onGetAssets,
    onOpenCategories,
    documentData,
    setSelectedLeftUrn,
    setSelectedRightUrn,
    openViewerLeft,
    openViewerRight,
    categoryOptions = {},
    linkViewersEnabled = false,
    onToggleLinkViewers
}) => {
    const { selectedCategoryId } = useGlobalProvider();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const selectRef = useRef(null);

    // const handleDocumentSelect = (event) => {
    //     const selectedUrn = event.target.value;
    //     // Find the full document object from documentData
    //     const document = documentData.find(doc => doc.itemUrn === selectedUrn);
    //     setSelectedDocument(document);
    // };

    // const handleGetAssetsClick = () => {
    //     onGetAssets();
    //     setSelectedDocument(null);
    //     if(selectRef.current) {
    //         selectRef.current.value = "";
    //     }
    // };

    // New handler to pass the selected document URN to the viewer bar
    const handleViewerDocumentSelect = (urn) => {
        const document = documentData.find(doc => doc.itemUrn === urn);
        setSelectedDocument(document);
    };

    // Check if the selected document is an Excel file
    const isExcelFile = () => {
        if (!selectedDocument) return false;
        
        const fileName = selectedDocument.displayName || selectedDocument.name || '';
        const extension = fileName.toLowerCase().split('.').pop();
        return extension === 'xls' || extension === 'xlsx';
    };


    
    // Determine if the select dropdown should be disabled
    const isSelectDisabled = !documentData || documentData.length === 0;

    // Get the category name for the button text
    const getCategoryButtonText = () => {
        if (selectedCategoryId && categoryOptions[selectedCategoryId]) {
            return categoryOptions[selectedCategoryId];
        }
        return "Categories";
    };

    return (
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
            <div className="btn-group me-2">
                <button className="btn btn-primary" onClick={onOpenCategories}>
                    {getCategoryButtonText()}
                </button>
            </div>
            
            {/* Link Viewers Toggle Switch */}
            <div className="me-2 d-flex align-items-center">
                <span className="me-2 small text-muted">Link Viewers:</span>
                <button
                    className={`btn btn-sm ${linkViewersEnabled ? 'btn-success' : 'btn-secondary'}`}
                    onClick={onToggleLinkViewers}
                    style={{ 
                        minWidth: '50px',
                        fontSize: '11px',
                        fontWeight: 'bold'
                    }}
                    title={linkViewersEnabled ? 
                        "Link Viewers is ON - Assets will auto-refresh when viewer selection changes" : 
                        "Link Viewers is OFF - Assets will only refresh when 'Get Assets' is clicked"
                    }
                >
                    {linkViewersEnabled ? 'ON' : 'OFF'}
                </button>
            </div>
            
            <div className="btn-group me-2">
                {/*<button className="btn btn-secondary" onClick={handleGetAssetsClick}>*/}
                {/*    Get Assets*/}
                {/*</button>*/}
                <button className="btn btn-secondary" onClick={onGetDocuments}>
                    Get documents
                </button>
            </div>
            
            <div className="btn-group me-2">
                <select
                    ref={selectRef}
                    className="form-select"
                    onChange={(e) => handleViewerDocumentSelect(e.target.value)}
                    defaultValue=""
                    disabled={isSelectDisabled}
                    style={{ minWidth: '300px' }} // Keep a consistent width
                >
                    <option value="" disabled>
                        {isSelectDisabled ? "No documents available" : "Select a document"}
                    </option>
                    {!isSelectDisabled && documentData.map((doc) => (
                        <option key={doc.itemUrn} value={doc.itemUrn}>
                            {doc.displayName}
                        </option>
                    ))}
                </select>
            </div>

            {/* Reusable viewer button bar */}
            <DocumentViewerButtonBar
                selectedDocument={selectedDocument}
                setSelectedLeftUrn={setSelectedLeftUrn}
                setSelectedRightUrn={setSelectedRightUrn}
                openViewerLeft={openViewerLeft}
                openViewerRight={openViewerRight}
            />

            {/* Link Excel button */}
            {/*<div className="btn-group ms-2" role="group" aria-label="Excel actions">*/}
            {/*    <button*/}
            {/*        type="button"*/}
            {/*        className={`btn btn-sm ${!isExcelFile() ? 'btn-outline-secondary' : 'btn-outline-success'}`}*/}
            {/*        // onClick={handleLinkExcel}*/}
            {/*        disabled={!isExcelFile()}*/}
            {/*        title={!isExcelFile() ? */}
            {/*            "Please select an Excel file (.xls or .xlsx) to enable this feature" : */}
            {/*            "Link Excel file functionality"*/}
            {/*        }*/}
            {/*    >*/}
            {/*        <i className="bi bi-file-earmark-excel"></i> Link Excel*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
};

export default AssetsButtonBar;